export enum Namespace {
  CookieConsentContent = 'cookieConsentContent',
  ServiceProviders = 'serviceProviders',
  WhereDoYouLive = 'whereDoYouLive',
  SupportPageContent = 'supportPageContent',
  AuthenticationV0 = 'authenticationV0', // landlords
  AuthenticationV1 = 'authenticationV1', // contact-form,
  AuthenticationV6 = 'authenticationV6', // contact-form,
  ContactFormContent = 'contactFormContent',
  SimplePage = 'simplePage',
  NoticeOfInterestGeneric = 'noticeOfInterestGeneric',
  NoticeOfInterestUpsell = 'noticeOfInterestUpsell',
  NoticeOfInterestFwa = 'noticeOfInterestFwa',
  NoticeOfInterestFwaLowband = 'noticeOfInterestFwaLowband',
  NoticeOfInterestFwaSiteDevelopment = 'noticeOfInterestFwaSiteDevelopment',
  NoticeOfInterestRural = 'noticeOfInterestRural',
  NoticeOfInterestOperatorChangeUpsell = 'noticeOfInterestOperatorChangeUpsell',
  NoticeOfInterestNoCapex = 'noticeOfInterestNoCapex',
  StatusPage = 'statusPage',
  OrderPage = 'orderPage',
  OrderSuccessPage = 'orderSuccessPage',
  RedirectModalContent = 'redirectModalContent',
  AddressSearchContent = 'addressSearchContent',
  Variable = 'variable',
  Landlord = 'landlord',

  LandlordContactFormContent = 'landlordContactFormContent',
  LandlordContactFormCaseReasons = 'landlordContactFormCaseReasons',
  LandlordOrderContent = 'landlordOrderContent',

  LandlordOrder = 'landlordOrder',
  LandlordOrderWizard = 'landlordOrderWizard',
  LandlordOrderOrganisation = 'landlordOrderOrganisation',
  LandlordOrderServices = 'landlordOrderServices',
  LandlordOrderContact = 'landlordOrderContact',
  LandlordOrderProperty = 'landlordOrderProperty',
  LandlordOrderSummary = 'landlordOrderSummary',
}
